module.exports = __webpack_public_path__ + "static/media/A13.07130541.mp3";